module.exports = __webpack_public_path__ + "img/mr.befe1be5.svg";